var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MembersOnlyTag member-icon"},[_vm._v("\n  会员专属\n  "),_c('i',{staticClass:"icon_member-box"},[_c('i',{staticClass:"icon_member"})])])
}]

export { render, staticRenderFns }